import { GraphQLClient } from 'graphql-request';

const commonOptions = {
  headers: {
    'X-Api-Key': import.meta.env.VITE_API_KEY_APP
  }
};

export const graphqlClients = {
  medicalProcedures:
    import.meta.env.MODE === 'development'
      ? new GraphQLClient('https://poradna.sandbox.ulekare.cz/api/graphql/medical-procedures', {
          'X-Api-Key': import.meta.env.VITE_SANDBOX_API_KEY
        })
      : new GraphQLClient(`${import.meta.env.VITE_BASE_API_URL}/graphql/medical-procedures`, {
          ...commonOptions
        }),
  appSettings: new GraphQLClient(`${import.meta.env.VITE_BASE_API_URL}/graphql/app-settings`, {
    ...commonOptions
  }),
  campaigns: new GraphQLClient(`${import.meta.env.VITE_BASE_API_URL}/graphql/campaigns`, {
    ...commonOptions
  }),
  files: new GraphQLClient(`${import.meta.env.VITE_BASE_API_URL}/graphql/files`, {
    ...commonOptions
  })
};

export const GraphqlPlugin = {
  install(Vue) {
    Vue.prototype.$graphql = graphqlClients;
  }
};
